import { Controller } from '@hotwired/stimulus';

/**
 * Displays a full-screen overlay with a spinner when a form is submitted.
 *
 * Usage:
 *   = simple_form_for resource, html: { data: { controller: 'form-saving-overlay', action: 'submit->form-saving-overlay#show' } } do |f|
 *
 * Customizable message:
 *   data-form-saving-overlay-message-value="更新中..."
 */
export default class extends Controller {
  static values = {
    message: { type: String, default: '保存中...' },
  };

  show() {
    // 二重表示を防止
    if (document.querySelector('.form-saving-overlay')) return;
    this.#createOverlay();
  }

  disconnect() {
    this.#removeOverlay();
  }

  #createOverlay() {
    const overlay = document.createElement('div');
    overlay.classList.add('form-saving-overlay');
    overlay.innerHTML = `
      <div class="form-saving-overlay__content">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
        <span class="form-saving-overlay__message">${this.messageValue}</span>
      </div>
    `;
    document.body.appendChild(overlay);
  }

  #removeOverlay() {
    const overlay = document.querySelector('.form-saving-overlay');
    if (overlay) overlay.remove();
  }
}
